/**
 * Computes visible part of scrollable area in the viewport when window is the scrollable element
 */
export function getWindowScrollOffset(parentElement: HTMLElement | null): number {
    const parentOffset = Math.max(parentElement?.getBoundingClientRect().y ?? 0, 0);
    return Math.max(window.scrollY - parentOffset, 0);
}

/**
 * Returns inline styles for the inner spacer element.
 * The spacer provides positioning context and holds the total virtual list height.
 */
export function getSpacerElementStyle(totalSize: number): string {
    return `position:relative;height:${totalSize}px;width:100%`;
}

/**
 * Returns inline styles for the parent viewport element when using inner spacer mode.
 * Applies overflow and max-height for scroll container behavior.
 */
export function getParentViewportStyle(maxHeight?: number | CSSStyleDeclaration['height']): string {
    if (maxHeight && typeof maxHeight === 'number') {
        return `overflow:auto;max-height:${maxHeight}px`;
    }

    if (maxHeight) {
        return `overflow:auto;max-height:${maxHeight}`;
    }

    return '';
}

export function getParentNode(
    node: HTMLElement | null,
    childSelector?: string,
): HTMLElement | null {
    if (childSelector) {
        return node?.querySelector<HTMLElement>(childSelector) ?? null;
    }
    return node;
}
